namespace $.$$ {
	export class $shm_hitalama_components_drag extends $.$shm_hitalama_components_drag {
		movable( id: string ) { return !this.locked() && this.catalog().can_change() && this.catalog().tree().movable( id ) }
		drag_buttons( id: string ) { return this.movable( id ) ? [ 0 ] : [] }
		can_have_children( id: string ) { return !id.startsWith( '$' ) }
		@ $mol_action
		apply_drop( id: string ) {
			if( !this.drop_active() || !this.movable( id ) ) return
			const parent = this.drop_parent() ?? ''
			const siblings = [ ...( parent ? this.children( parent ) : this.roots() ) ].filter( child => child !== id )
			siblings.splice( this.drop_index(), 0, id )
			this.catalog().node_move( id, parent, this.reversed() ? siblings.reverse() : siblings )
		}
	}
}
